var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dictionary-modal-table',{attrs:{"dictionary_link":"/product-lines","title":"Lista linii produktów","numeral_text":['linia produktów', 'linie produktów', 'linii produktów'],"columns_title":['name']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }